import { render, staticRenderFns } from "./InserirAtualizarDespesaForm.vue?vue&type=template&id=01540a01"
import script from "./InserirAtualizarDespesaForm.vue?vue&type=script&lang=js"
export * from "./InserirAtualizarDespesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports